const STORAGE_KEY_PREFIX = 'subscription_expired_notice_shown_';

export function getSubscriptionExpiredNoticeDismissKey(orgId) {
  const id = orgId ? String(orgId) : 'unknown';
  return `${STORAGE_KEY_PREFIX}${id}`;
}

export function wasSubscriptionExpiredNoticeShownThisSession(orgId) {
  try {
    return !!sessionStorage.getItem(getSubscriptionExpiredNoticeDismissKey(orgId));
  } catch (e) {
    return false;
  }
}

export function markSubscriptionExpiredNoticeShownThisSession(orgId) {
  try {
    sessionStorage.setItem(getSubscriptionExpiredNoticeDismissKey(orgId), '1');
  } catch (e) {
    // ignore storage access errors
  }
}

export function getSubscriptionExpiredNoticeContent(org) {
  const defaultMessage = 'Your subscription has expired. Please contact your account manager.';

  if (!org) {
    return { message: defaultMessage };
  }

  const rawMessage = org.subscriptionExpiredNoticeMessage;
  const message = rawMessage && String(rawMessage).trim() ? rawMessage : defaultMessage;
  return { message };
}

export function isSubscriptionExpiredNoticeEnabled(org) {
  return !!(org && org.subscriptionExpiredNoticeEnabled);
}
